
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/delivery",
      function () {
        return require("private-next-pages/checkout/delivery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/delivery"])
      });
    }
  